module.exports = __webpack_public_path__ + "static/media/3DPPA11.13c14b91.jpg";